import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../formInputsV2/styles/tokens';

// v2 look of the "Modifica Preventivo" back link: same outline button as
// "Modifica Dati" in the result pages' summary cards.
export const ModificaBackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 9px 16px;
  border: 1.5px solid ${v2Colors.primaryBorder};
  border-radius: 10px;
  background: #fff;
  font-family: ${v2FontFamily};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  color: ${v2Colors.primary};
  cursor: pointer;
  transition: border-color 150ms ease, background-color 150ms ease;

  svg {
    font-size: 14px;
  }

  &:hover,
  &:focus-visible {
    border-color: ${v2Colors.primary};
    background: ${v2Colors.primarySoft};
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    padding: 7px 12px;
    font-size: 13px;
  }
`;
